import { useMutation } from '@tanstack/react-query';
import { orpc } from 'src/api/rpc/client';

export function useRequestPasswordReset() {
  return useMutation(orpc.auth.requestPasswordReset.mutationOptions());
}
